export default __webpack_public_path__ + "static/media/copyright-line.9a80b30b.svg";